import React, { useEffect } from 'react'
import {
  Grid,
  CircularProgress
} from '@material-ui/core'
import { withRouter } from 'react-router-dom'

// styles
import useStyles from './styles'

// context
import { useUserDispatch, loginUser, signOut } from '../../contexts/UserContext'

function Login (props) {
  const classes = useStyles()

  // global
  const userDispatch = useUserDispatch()

  useEffect(() => {
    if (props.history.location.state && props.history.location.state.from) {
      signOut(props.history.location.state.from)
    } else {
      ;(async () => loginUser(userDispatch, props.history, props.token, props.expiry, props.stateCode))()
    }
  }, [props.expiry, props.history, props.stateCode, props.token, userDispatch])

  return (
    <Grid container className={classes.container}>
      <CircularProgress size={26} className={classes.loginLoader} />
    </Grid>
  )
}

export default withRouter(Login)
